import { ConnectionType } from '@/features/print/constants'
import { FormOutput } from '@/features/settings/components/AddPrinterModal/form/types'
import { AddPrinterData } from '@/features/settings/contexts/AddPrinter'
import { SunmiPrinterInfo } from '@/modules/sunmi-printer'

export const createAddPrinterData = (
    form: FormOutput,
    sunmiDefaultPrinterInfo: SunmiPrinterInfo | null | undefined
): AddPrinterData => {
    if (form.connectionType === ConnectionType.Network) {
        if (!form.ipAddress) {
            throw new Error('Network printer IP address is missing.')
        }

        return {
            connectionType: ConnectionType.Network,
            ipAddress: form.ipAddress,
        }
    }

    if (form.connectionType === ConnectionType.SunmiDefault) {
        if (!sunmiDefaultPrinterInfo) {
            throw new Error('Sunmi default printer information is missing.')
        }

        return {
            connectionType: ConnectionType.SunmiDefault,
            printerInfo: sunmiDefaultPrinterInfo,
        }
    }

    throw new Error('Invalid connection type.')
}
